// extracted by mini-css-extract-plugin
export default {"appContainer":"organization_appContainer__bYvWq","mainContent":"organization_mainContent__Zl-yj"};